import React from 'react';
import { View } from '@react-pdf/renderer';
import { styles } from '../PDFStyles.style';

const TableRow: React.FC = ({ children }) => {
  return <View style={styles.tableRow}>{children}</View>;
};

export default TableRow;
